"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;exports.__esModule = true;exports.LightTheme5_3 = void 0;var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));var _ThemeHelpers = require("../../lib/theming/ThemeHelpers");

var _BasicTheme = require("./BasicTheme");
var _LightTheme5_2 = require("./LightTheme5_2");var _LightTheme5_;

var LightTheme5_3 = exports.LightTheme5_3 = (0, _ThemeHelpers.createTheme)({
  themeClass: (_LightTheme5_ = /*#__PURE__*/function (_BasicThemeClassForEx) {function LightTheme5_3() {return _BasicThemeClassForEx.apply(this, arguments) || this;}(0, _inheritsLoose2.default)(LightTheme5_3, _BasicThemeClassForEx);return LightTheme5_3;}(_BasicTheme.BasicThemeClassForExtension), _LightTheme5_.

  miniModalDescriptionFontSize = '16px', _LightTheme5_.
  miniModalDescriptionLineHeight = '22px', _LightTheme5_),


  prototypeTheme: _LightTheme5_2.LightTheme5_2,
  themeMarkers: [(0, _ThemeHelpers.markThemeVersion)('5.3')]
});